new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if(bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if(bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    } 

    const productRatings = document.querySelector('.product-ratings');
    if(productRatings) {
        $('.product-ratings-list').slick({
            arrows: false,
            dots: true,
            autoplay: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 1000,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });
    }
});